// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'

import VueJSModal from 'vue-js-modal'
import Paginate from 'vuejs-paginate'
import VueLoadingOverlay from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(VueJSModal)
Vue.component('paginate', Paginate)
Vue.use(VueLoadingOverlay)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js